import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("[ErrorBoundary]", error, info.componentStack);
    }
    handleReset = () => {
        this.props.onReset?.();
        this.setState({ hasError: false, error: null });
    };
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsx("div", { className: "min-h-screen flex items-center justify-center bg-surface-bg px-4", children: _jsxs("div", { className: "max-w-md w-full bg-surface-white border border-surface-border rounded-2xl p-6 shadow-sm text-center", children: [_jsx("div", { className: "h-12 w-12 rounded-full bg-error/10 flex items-center justify-center mx-auto mb-4", children: _jsx("span", { className: "text-error text-xl font-bold", children: "!" }) }), _jsx("h2", { className: "text-lg font-semibold text-text-primary mb-2", children: "Something went wrong" }), _jsx("p", { className: "text-sm text-text-secondary mb-4", children: "An unexpected error occurred. Please try reloading the page." }), this.state.error && (_jsx("pre", { className: "text-left text-xs bg-surface-input rounded-lg p-3 mb-4 overflow-auto max-h-32 text-error", children: this.state.error.message })), _jsx("button", { onClick: this.handleReset, className: "px-4 py-2 rounded-xl bg-brand-blue text-white text-sm font-medium hover:bg-brand-blue/90 transition-colors", children: "Try Again" })] }) }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=error-boundary.js.map